export default __webpack_public_path__ + "static/media/card2.aae73ef1.jpg";